import { initializeApp,getApps,getApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useDispatch } from "react-redux";
import { firebaseConfig,firebaseProdConfig } from "../config/firebase-config";
import { LOGIN, LOGOUT } from "../redux/constants/constants";

const FirebaseApp = getApps().length === 0 ? initializeApp(process.env.NODE_ENV === 'production' ? firebaseConfig : firebaseConfig ) : getApp();
// const FirebaseAuth = getAuth(app)
export default FirebaseApp;